import React from 'react';

interface Props {
    title: string;
    intro?: string;
    children: React.ReactNode;
}

const QueryHelpPageLayout = React.memo<Props>(({title, intro, children}) => (
    <div className="query-help-modal__page">
        <header className="query-help-modal__page-header">
            <h3 className="query-help-modal__page-title">{title}</h3>
            {intro ? <p className="query-help-modal__page-intro">{intro}</p> : null}
        </header>
        <div className="query-help-modal__page-body">
            {children}
        </div>
    </div>
));

export default QueryHelpPageLayout;
